﻿/**
* DevExpress Dashboard (form-item-templates.js)
* Version:  20.1.8
* Build date: Oct 12, 2020
* Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var button_group_1 = require("devextreme/ui/button_group");
var ko = require("knockout");
var FormItemTemplates = (function () {
    function FormItemTemplates() {
    }
    FormItemTemplates.buttonGroup = function (args) {
        var div = document.createElement('div');
        var options = __assign({ width: '100%', onSelectionChanged: function (e) { return args.component.updateData(args.dataField, e.component.option('selectedItemKeys')[0]); }, selectedItemKeys: [ko.unwrap(args.component.option('formData')[args.dataField])] }, args.editorOptions);
        new button_group_1.default(div, options);
        return div;
    };
    return FormItemTemplates;
}());
exports.FormItemTemplates = FormItemTemplates;
